import { muscleRegion } from "./taxonomy.js";
import { exerciseTraits } from "./exerciseTraits.js";
import type { Exercise } from "./schemas/exercise.js";

// Build a starter tag set from the exercise's structural fields. Used by
// the catalog editor's "Suggest tags" affordance so coaches don't have to
// retype labels the schema already knows. The user is free to delete any
// suggestion and add custom tags on top — we never auto-overwrite the
// stored `tags` array.
//
// Tag vocabulary covers four useful axes for filtering and reporting:
//   * primary muscle slugs (e.g. "biceps")
//   * region derived from primary[0] (e.g. "arms")
//   * movementPattern (e.g. "isolation")
//   * equipment (e.g. "barbell")
// Plus the "bodyweight" label when the flag is set, which is a common
// search shorthand even if `equipment="bodyweight"` already covers it.
export function suggestTags(
  ex: Pick<
    Exercise,
    "primary" | "primaryMuscle" | "movementPattern" | "equipment" | "isBodyweight" | "region"
  >,
): string[] {
  const out: string[] = [];
  const primary = ex.primary && ex.primary.length > 0
    ? ex.primary
    : ex.primaryMuscle
      ? [ex.primaryMuscle]
      : [];
  for (const slug of primary) out.push(slug);
  const region = ex.region ?? (primary[0] ? muscleRegion(primary[0]) : null);
  if (region) out.push(region);
  if (ex.movementPattern) out.push(ex.movementPattern);
  if (ex.equipment) out.push(ex.equipment);
  if (exerciseTraits(ex).isBodyweight) out.push("bodyweight");
  // Dedupe in input order so the chip layout reads from-most-specific to
  // least-specific (muscles first).
  return Array.from(new Set(out));
}
